<template>
    <div class='found-order-list'>
      <div class='order-list' v-for="item in formData" :key='item.id' >
            <ul @click="handleJumpOrderDetail(item.id)">
                <li>
                    <p><span class="lg-list-title" style="padding: 0">{{item.title}}</span><span>{{item.category}}</span></p>
                    <p class="lg-price"><img class="icon-money" src="../../assets/img/icon-pig.png" alt=""><span>{{item.price}}</span>{{getSettingConfig.getInfo('currency_name')}}</p>
                </li>
                <li class='order-info'>
	                <span class="lg-list-item">报名截止日期：{{item.signed_at}}</span>
	                <span class="lg-list-item">{{item.status === 0 && item.user_id !== null ? '指定设计师':data[item.status]}}</span></li>
                <li class='order-info'>
                  <div>
                    <p class="lg-list-item">{{item.firm_name}} <img src="../../assets/img/order2.png" alt=""></p>
	                  <p class="firm-rate">
		                  <el-rate :colors="colors" :value="parseFloat(item.firm_rate) === 0 || item.firm_rate === 'null' ? 5 :parseFloat(item.firm_rate)" disabled :allow-half="true" />
	                  </p>
                  </div>
                  <div><p class="lg-list-item">{{item.created_at}}</p></div>
                </li>
            </ul>
            <img v-if="!item.is_disabled  && (item.status === 0 && !item.is_take_order)" class="apply-img hover-appear" src="../../assets/img/order.png" alt="">
            <button
		        v-if="!item.is_disabled && (item.status === 0 && !item.is_take_order)"
		        class="apply-btn hover-appear"
		        @click="handleApplyOrder(item.id)"
            >
	            {{item.is_take_order ? '已申请':'申请接单'}}
            </button>
        </div>
	    <agreement ref="dialogChildren" />
    </div>
</template>

<script>
	import agreement from '../agreementDialog/index'
export default {
  props:['formData'],
  components:{agreement},
    data () {
        return {
          colors:['#ffde00','#ffde00','#ffde00','#ffde00','#ffde00'],
          data:{
            0:'任务未开始',
            1:'任务已开始',
            2:'任务已结束',
            3:'任务已取消'
          }
        }
    },
    methods: {
      handleJumpOrderDetail(data){
        const {href} = this.$router.resolve({
          name: 'task_detail',
          query: {
            id:data
          }
        })
        window.open(href, '_blank')
      },
      handleApplyOrder(data) {
        const status = this.$utils.loginStatus()
        status ? this.$refs.dialogChildren.handleOpenDialog(data):""
      }
    },
}
</script>
<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/components/order/index.vue